<template lang="html">
  <img class="pt-3 mb-4" src="@/assets/logo.svg" alt="logo" width="250" />
  <div class="container-fluid">
    <h1 class="title h-100">
      fill in this short survey <br />
      for a chance <br />to win a day off.
    </h1>
    <input
      v-model="firstName"
      class="form-control field no-focusborder"
      type="text"
      ref="inputfield"
      placeholder="Naam"
      required
    />
    <!--
    <input
      v-model="lastName"
      class="form-control field no-focusborder"
      type="text"
      ref="inputfield"
      placeholder="Achternaam"
      required
    />

    <input
      v-model="email"
      class="form-control field no-focusborder"
      type="email"
      ref="inputfield"
      placeholder="E-mail adres"
      required
    />
    {{ validateEmail }}
    <input
      v-model="phone"
      class="form-control field no-focusborder"
      type="text"
      ref="inputfield"
      placeholder="Mobiel nummer"
      required
    />
    <input
      v-model="company"
      class="form-control field no-focusborder"
      type="text"
      ref="inputfield"
      placeholder="Bedrijfsnaam (optioneel)"
      required
    />

    <input
      v-model="jobposition"
      class="form-control field no-focusborder"
      type="text"
      ref="inputfield"
      placeholder="Functie"
      required
    />
  -->
    <div class="d-grid gap-2 pt-2">
      <button
        type="button"
        class="btn btn-primary btn-lg rounded-pill"
        :disabled="isDisabled == true"
        @click="setPersonalData()"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    company: null,
    jobposition: null,
  }),
  computed: {
    isDisabled() {
      if (this.firstName) {
        return false;
      }
      return true;
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Please enter a valid email address";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      this.$store.commit("setCompany", this.company);
      this.$store.commit("setPhone", this.phone);
      this.$store.commit("setEmail", this.email);
      this.$store.commit("setJobPosition", this.jobposition);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";

h1 {
  font-size: 30px;
  font-family: $font-family-serif;
  color: $text-color;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin-bottom: 10px !important;
  outline: none;
  padding: 10px;
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 20px;
  background-color: #fff;
  width: 100% !important;
  box-sizing: border-box;
}
</style>
